import { Box, Typography, Chip } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import dayjs from 'dayjs';
import ChangelogLayout from './ChangelogLayout';

function NewsItem({ news }) {
  const formatDate = dateString => {
    return dayjs(dateString).format('YYYY-MM-DD');
  };

  return (
    <ChangelogLayout title={news.title} date={formatDate(news.date)}>
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
        {Array.isArray(news.authors) &&
          news.authors.map((a, idx) => {
            const authorId = typeof a === 'object' ? a._id : a;
            const name =
              (typeof a === 'object' &&
                ([a.firstName, a.lastName].filter(Boolean).join(' ') || a.username)) ||
              a;
            return (
              <Chip
                key={`${news._id}-author-${authorId}-${idx}`}
                label={name}
                size='small'
                variant='outlined'
              />
            );
          })}
      </Box>
      <Box
        sx={{
          textAlign: 'left',
          '& h1': {
            fontSize: '2rem',
            fontWeight: 600,
            margin: '0.5em 0',
            textAlign: 'left',
          },
          '& h2': {
            fontSize: '1.5rem',
            fontWeight: 600,
            margin: '0.5em 0',
            textAlign: 'left',
          },
          '& h3': {
            fontSize: '1.25rem',
            fontWeight: 600,
            margin: '0.5em 0',
            textAlign: 'left',
          },
          '& ul, & ol': {
            margin: '0.5em 0',
            paddingLeft: '2em',
            textAlign: 'left',
          },
          '& p': {
            margin: '0.5em 0',
            textAlign: 'left',
          },
        }}
        dangerouslySetInnerHTML={{ __html: news.content }}
      />
    </ChangelogLayout>
  );
}

export default NewsItem;

